var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.634,
    height: 25.604,
    viewBox: "0 0 25.634 25.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.212,
    y1: 0.111,
    x2: 0.871,
    y2: 0.888,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76ffa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41cad9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 25.634,
    height: 25.604,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M12.833,0A12.816,12.816,0,0,0,.032,12.8a12.678,12.678,0,0,0,2.75,7.925L.43,23.079A1.516,1.516,0,0,0,.12,24.73a1.494,1.494,0,0,0,1.359.874H12.833a12.8,12.8,0,0,0,0-25.6M5.9,21.85A1.47,1.47,0,0,0,6.345,20.8,1.489,1.489,0,0,0,5.9,19.73a9.792,9.792,0,1,1,6.929,2.862H5.166Z",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.d97668f2c0a02c374d213842ae6b9b34.svg";
export { ForwardRef as ReactComponent };